import AfbInvestmentAdmin from './AfbInvestmentAdmin';

export * from "./hooks/useInvestmentAdmin"

export default AfbInvestmentAdmin;